// @ts-nocheck
export const MESSAGE_CONTAINER_SCROLL = "MESSAGE_CONTAINER_SCROLL";

// chat rooms...
export const ON_SELECT_NEW_CHAT_ROOM = "ON_SELECT_NEW_CHAT_ROOM";
export const ADD_NEW_CHAT_ROOM_PARTICIPANT_SIDE = "ADD_NEW_CHAT_ROOM_PARTICIPANT_SIDE";
export const ADD_NEW_CHAT_ROOM_LOADING = "ADD_NEW_CHAT_ROOM_LOADING";
export const ADD_NEW_CHAT_ROOM_SUCCESS = "ADD_NEW_CHAT_ROOM_SUCCESS";
export const ADD_NEW_CHAT_ROOM_FAILURE = "ADD_NEW_CHAT_ROOM_FAILURE";
// chat rooms...

// chat room messages...
export const FETCH_CHAT_ROOM_MESSAGES_LOADING = "FETCH_CHAT_ROOM_MESSAGES_LOADING";
export const FETCH_CHAT_ROOM_MESSAGES_SUCCESS = "FETCH_CHAT_ROOM_MESSAGES_SUCCESS";
export const FETCH_CHAT_ROOM_MESSAGES_FAILURE = "FETCH_CHAT_ROOM_MESSAGES_FAILURE";
export const ON_NEW_MESSAGE = "ON_NEW_MESSAGE";
// chat room messages...

// reset slice...
export const RESET_SLICE_ONE_ON_ONE_MESSAGING = "RESET_SLICE_ONE_ON_ONE_MESSAGING";
// reset slice...